<!-- =========================================
     SANGEETHA TOYS — ABOUT US PAGE
     Reference: Sky-blue cloud hero, Our Story
     with kids photo, blue mission box,
     4-stat row, feature cards, white/sky palette
========================================= -->

<app-navbar-style-two></app-navbar-style-two>

<!-- ═══════════════════════════════════════
     HERO — Sky-blue cloud banner
═══════════════════════════════════════ -->
<section class="au-hero">

  <div class="au-hero__clouds" aria-hidden="true">
    <div class="cloud cloud--lg cloud--1"></div>
    <div class="cloud cloud--md cloud--2"></div>
    <div class="cloud cloud--sm cloud--3"></div>
    <div class="cloud cloud--md cloud--4"></div>
    <div class="cloud cloud--sm cloud--5"></div>
  </div>

  <span class="au-star s1" aria-hidden="true">★</span>
  <span class="au-star s2" aria-hidden="true">✦</span>
  <span class="au-star s3" aria-hidden="true">★</span>
  <span class="au-star s4" aria-hidden="true">✦</span>

  <div class="container">
    <div class="row align-items-center">

      <div class="col-lg-6">
        <div class="au-hero__text">
          <h1 class="au-hero__title">About Us</h1>
          <p class="au-hero__sub">
            Bringing joy, learning and smiles to every child.
            Thank you for choosing <strong>Sangeetha Toys!</strong> 💙
          </p>
          <div class="au-hero__pills">
            <span class="au-hero__pill"><i class='bx bx-check-shield'></i> 100% Safe Toys</span>
            <span class="au-hero__pill"><i class='bxs-star bx'></i> 4.8★ Rated</span>
            <span class="au-hero__pill"><i class='bx bx-group'></i> 1000+ Customers</span>
          </div>
          <div class="au-hero__cta">
            <a routerLink="/menu" class="au-cta-btn au-cta-btn--outline " style="background:#00bbf9 ">Shop Now →</a>
            <a routerLink="/contact" class="au-cta-btn au-cta-btn--outline text-black" style="background:#fee440">Get In
              Touch</a>
          </div>
        </div>
      </div>

      <div class="col-lg-6 d-flex justify-content-center">
        <div class="au-hero__img-wrap">
          <div class="au-hero__img-circle" aria-hidden="true"></div>
          <img src="assets/img/toys/teddy1.png" alt="Cute teddy bear toy" class="au-hero__toy">
          <span class="au-hero__plane" aria-hidden="true">✈️</span>
          <span class="au-sparkle sp1" aria-hidden="true">✦</span>
          <span class="au-sparkle sp2" aria-hidden="true">★</span>
          <span class="au-sparkle sp3" aria-hidden="true">✦</span>
        </div>
      </div>

    </div>
  </div>

  <div class="au-hero__wave" aria-hidden="true">
    <svg viewBox="0 0 1440 70" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0,35 C360,70 1080,0 1440,35 L1440,70 L0,70 Z" fill="#ffffff" />
    </svg>
  </div>

</section>


<!-- ═══════════════════════════════════════
     OUR STORY
═══════════════════════════════════════ -->
<section class="au-story">
  <div class="container">
    <div class="row align-items-center g-5">

      <div class="col-lg-6">
        <span class="au-eyebrow">📖 Our Story</span>
        <h2 class="au-section-h2">Creating Smiles<br>Since Day One</h2>

        <p class="au-story__para">
          <strong class="au-story__brand">Sangeetha Toys</strong> was founded with a
          simple mission — to bring safe, high-quality and creative toys that make
          every child smile and learn while playing.
        </p>

        <p class="au-story__para">
          We believe every child deserves toys that spark imagination, encourage
          learning, and create unforgettable memories. Our collection spans
          educational toys, action figures, puzzles, dolls, vehicles, and much more.
        </p>

        <div class="au-mission-box d-none">
          <div class="au-mission-box__icon"><i class='bx bxs-bullseye'></i></div>
          <div class="au-mission-box__text">
            <strong>Our Mission</strong>
            <p>To provide the best toys that inspire creativity, learning and happiness.</p>
          </div>
        </div>

        <div class="au-highlights">
          <div class="au-highlight">
            <span class="au-check"><i class='bx bx-check'></i></span>
            Carefully curated, age-appropriate toy collections
          </div>
          <div class="au-highlight">
            <span class="au-check"><i class='bx bx-check'></i></span>
            Sourced from trusted, quality-tested brands
          </div>
          <div class="au-highlight">
            <span class="au-check"><i class='bx bx-check'></i></span>
            Friendly support &amp; hassle-free shopping experience
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="au-story__img-wrap">
          <div class="au-story__img-frame">
            <img src="assets/img/slider/about-img.jpg" alt="Children playing with toys" class="au-story__photo">
          </div>
          <div class="au-float-badge">
            <span class="au-float-badge__emoji">🎁</span>
            <div>
              <strong>100% Safe</strong>
              <small>Tested for kids</small>
            </div>
          </div>
          <div class="au-rating-badge">
            <span class="au-rating-badge__stars">★★★★★</span>
            <span class="au-rating-badge__text">4.8 / 5 Rating</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>


<!-- ═══════════════════════════════════════
     STATS ROW — 4 counters matching reference
═══════════════════════════════════════ -->
<section class="au-stats d-none">
  <div class="container">
    <div class="au-stats__strip">

      <div class="au-stat">
        <h3>1000<span class="au-stat__plus">+</span></h3>
        <p>Happy Customers</p>
      </div>

      <div class="au-stats__line" aria-hidden="true"></div>

      <div class="au-stat">
        <h3>500<span class="au-stat__plus">+</span></h3>
        <p>Products</p>
      </div>

      <div class="au-stats__line" aria-hidden="true"></div>

      <div class="au-stat">
        <h3>99<span class="au-stat__plus">%</span></h3>
        <p>Positive Reviews</p>
      </div>

      <div class="au-stats__line" aria-hidden="true"></div>

      <div class="au-stat">
        <h3>4.8<span class="au-stat__star">★</span></h3>
        <p>Average Rating</p>
      </div>

    </div>
  </div>
</section>


<!-- ═══════════════════════════════════════
     WHY PARENTS CHOOSE US — 4 cards
═══════════════════════════════════════ -->
<!-- <section class="au-why">
  <div class="container">

    <div class="au-section-header text-center">
      <span class="au-eyebrow">💛 Why Choose Us</span>
      <h2 class="au-section-h2">Why Parents Love Sangeetha Toys</h2>
      <p class="au-section-sub">
        Safe, educational, and joyful toys that bring smiles to every child.
      </p>
    </div>

    <div class="row g-4">

      <div class="col-lg-3 col-md-6">
        <div class="au-why-card">
          <div class="au-card-glow"></div>
          <div class="au-why-card__icon-wrap quality">
            <span class="au-why-card__icon">🛡️</span>
          </div>
          <h4>Premium Quality</h4>
          <p>Every toy is carefully selected and tested for long-lasting durability.</p>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="au-why-card">
          <div class="au-card-glow"></div>
          <div class="au-why-card__icon-wrap safety">
            <span class="au-why-card__icon">👶</span>
          </div>
          <h4>Kid Safe</h4>
          <p>Made from child-friendly materials with safety as our top priority.</p>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="au-why-card">
          <div class="au-card-glow"></div>
          <div class="au-why-card__icon-wrap delivery">
            <span class="au-why-card__icon">🚚</span>
          </div>
          <h4>Fast Delivery</h4>
          <p>Quick shipping and secure packaging for a delightful unboxing experience.</p>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="au-why-card">
          <div class="au-card-glow"></div>
          <div class="au-why-card__icon-wrap returns">
            <span class="au-why-card__icon">🔄</span>
          </div>
          <h4>Easy Returns</h4>
          <p>Simple return process backed by responsive customer support.</p>
        </div>
      </div>

    </div>

  </div>
</section> -->

<section class="why-choose-section">
  <div class="container">
    <div class="section-header">
      <div class="badge">⭐ OUR PROMISE</div>
      <h2>Why Parents Love <span>Sangeetha Toys</span></h2>
      <p>Safe, educational, and joyful toys that bring smiles to every child.</p>
    </div>

    <div class="feature-grid">
      <div class="feature-card" *ngFor="let feature of features" [ngClass]="feature.cardClass">
        <div class="feature-number">{{ feature.number }}</div>

        <div class="icon-circle">
          <!-- <span>{{ feature.icon }}</span> -->
          <img style="border-radius:10px;" src="{{ feature.image }}" alt="{{ feature.title }}">
        </div>

        <h3>{{ feature.title }}</h3>
        <div class="title-underline"></div>
        <p>{{ feature.description }}</p>

        <div class="card-bottom-illustration">
          <!-- <span>{{ feature.icon }}</span> -->
          <img class="w-75" src="{{ feature.image1 }}" alt="{{ feature.title }}">
        </div>
      </div>
    </div>

    <div class="trust-strip">
      <div class="trust-item" *ngFor="let item of trustPoints; let last = last">
        <div class="trust-icon" [ngStyle]="{
    'background-image': 'url(' + item.icon + ')'
  }"></div>
        <span>{{ item.text }}</span>
        <div class="divider" *ngIf="!last"></div>
      </div>
    </div>
  </div>
</section>

<!-- ═══════════════════════════════════════
     TRUST BANNER — blue strip with 5 pills
     (matches reference "Why Parents Choose" section)
═══════════════════════════════════════ -->
<section class="au-trust-banner">
  <div class="container">
    <div class="au-trust-banner__inner">

      <div class="au-trust-banner__left">
        <h2>Why Parents Choose<br>Sangeetha Toys?</h2>
        <a routerLink="/menu" class="au-trust-banner__btn">Shop Now →</a>
      </div>

      <div class="au-trust-banner__pills">
        <div class="au-trust-pill">
          <span class="au-trust-pill__icon"><img src="../assets/img/toy_icons/icon_7.png" class="image" alt=""></span>
          <span>Premium<br>Quality</span>
        </div>
        <div class="au-trust-pill">
          <span class="au-trust-pill__icon"><img src="../assets/img/toy_icons/icon_8.png" class="image" alt=""></span>
          <span>Child Safe<br>Materials</span>
        </div>
        <div class="au-trust-pill">
          <span class="au-trust-pill__icon"> <img src="../assets/img/toy_icons/icon_9.png" class="image" alt=""></span>
          <span>Affordable<br>Prices</span>
        </div>
        <div class="au-trust-pill">
          <span class="au-trust-pill__icon"> <img src="../assets/img/toy_icons/icon_6.png" class="image" alt=""></span>
          <span>Loved by<br>1000+ Parents</span>
        </div>
        <div class="au-trust-pill">
          <span class="au-trust-pill__icon"><img src="../assets/img/toy_icons/icon_10.png" class="image" alt=""></span>
          <span>Secure<br>Payments</span>
        </div>
      </div>

    </div>
  </div>
</section>


<!-- ═══════════════════════════════════════
     MISSION & VISION
═══════════════════════════════════════ -->
<!-- <section class="au-mv">
  <div class="container">

    <div class="au-section-header text-center mb-5">
      <span class="au-eyebrow">🎯 Our Purpose</span>
      <h2 class="au-section-h2">Mission &amp; Vision</h2>
    </div>

    <div class="row g-4">
      <div class="col-md-6">
        <div class="au-mv-card au-mv-card--red">
          <div class="au-mv-card__emoji" aria-hidden="true">🎯</div>
          <h3>Our Mission</h3>
          <p>To provide children with exciting, safe and affordable toys that encourage imagination, creativity, learning and happiness while ensuring the highest standards of quality.</p>
          <ul class="au-mv-list">
            <li><i class='bx bx-check-circle'></i> Age-appropriate collections</li>
            <li><i class='bx bx-check-circle'></i> Quality you can trust</li>
            <li><i class='bx bx-check-circle'></i> Joy in every box</li>
          </ul>
        </div>
      </div>
      <div class="col-md-6">
        <div class="au-mv-card au-mv-card--blue">
          <div class="au-mv-card__emoji" aria-hidden="true">🚀</div>
          <h3>Our Vision</h3>
          <p>To become the most trusted toy destination where families discover products that create joyful childhood experiences and lifelong memories — delivered with love and care.</p>
          <ul class="au-mv-list">
            <li><i class='bx bx-check-circle'></i> Most trusted toy store</li>
            <li><i class='bx bx-check-circle'></i> Happy families nationwide</li>
            <li><i class='bx bx-check-circle'></i> Lifelong childhood memories</li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</section> -->



<section class="mission-vision-section">
  <div class="container">
    <div class="section-header mb-1">
      <div class="badge">⭐ OUR PURPOSE</div>

      <div class="d-flex justify-content-center align-items-center justify-content-between">
        <img class='purpose-img' src="../assets/img/toy_icons/icon_15.png" alt="">
        <div>
          <h1 style="font-weight:900">Why <span class="purpose">Families</span> Choose Us</h1>
          <p>We’re on a mission to make playtime safer, happier, and more meaningful for every child.</p>
        </div>
        <img class='purpose-img' src="../assets/img/toy_icons/icon_16.png" alt="">
      </div>

      <!-- <h1 class="text-bold">Why <span class="purpose">Families</span>  Choose Us</h1>
      <p>We’re on a mission to make playtime safer, happier, and more meaningful for every child.</p> -->
    </div>

    <div class="mv-grid">
      <!-- Mission Card -->
      <div class="mv-card mission-card">
        <div class="mv-icon " [style.background-image]="'url(assets/img/toy_icons/icon_13.png)'"> </div>
        <h3>Our Mission</h3>
        <div class="underline"></div>

       <p class="mv-desc">
  To bring children safe, affordable, and exciting toys that inspire imagination, creativity, and joyful learning while creating memorable play experiences for every family.
</p>
        <div class="wave-shape d-none">
          <svg viewBox="0 0 350 240" preserveAspectRatio="none">
            <path d="M350,0
             L350,240
             C290,240 280,200 250,180
             C210,150 210,110 170,90
             C130,70 90,50 0,40
             L0,0 Z" />
          </svg>
        </div>
        <!-- <ul>
          <li *ngFor="let item of missionPoints">✔ {{ item }}</li>
        </ul>  -->

        <div class="d-flex">
          <ul>
            <li *ngFor="let item of missionPoints"> {{ item }}</li>
          </ul>
          <img class='w-25' src="../assets/img/slider/missionimg.png" alt="">
        </div>
      </div>

      <!-- Vision Card -->
      <div class="mv-card vision-card">
        <div class="mv-icon" [style.background-image]="'url(assets/img/toy_icons/icon_14.png)'"></div>
        <h3>Our Vision</h3>
        <div class="underline"></div>

        <p class="mv-desc">
  To become the most trusted toy destination for families by offering quality products, exceptional service, and joyful experiences that children love and parents trust.
</p>

        <div class="d-flex">
          <ul>
            <li *ngFor="let item of visionPoints"> {{ item }}</li>
          </ul>
          <img class='w-25' src="../assets/img/slider/vissionimg2.png" alt="">
        </div>

      </div>
    </div>

    <div class="bottom-values d-none">
      <div class="value-item">
        <span>🛡️</span>
        <p>Safe & Non-Toxic Materials</p>
      </div>
      <div class="value-item">
        <span>🏅</span>
        <p>Quality You Can Trust</p>
      </div>
      <div class="value-item">
        <span>📦</span>
        <p>Thoughtfully Curated</p>
      </div>
      <div class="value-item">
        <span>💖</span>
        <p>Made for Happy Childhoods</p>
      </div>
    </div>
  </div>
</section>


<!-- ═══════════════════════════════════════
     TOY CATEGORIES GRID
═══════════════════════════════════════ -->
<section class="au-cats d-none">
  <div class="container">

    <div class="au-section-header text-center mb-5">
      <span class="au-eyebrow">🧩 Toy World</span>
      <h2 class="au-section-h2">Explore Our Toy World</h2>
    </div>

    <div class="au-cats__grid">
      <a routerLink="/menu" class="au-cat"><span class="au-cat__emoji">🤖</span><span class="au-cat__label">Educational
          Toys</span></a>
      <a routerLink="/menu" class="au-cat"><span class="au-cat__emoji">🚗</span><span class="au-cat__label">Remote
          Control Cars</span></a>
      <a routerLink="/menu" class="au-cat"><span class="au-cat__emoji">🧩</span><span class="au-cat__label">Puzzles
          &amp; Games</span></a>
      <a routerLink="/menu" class="au-cat"><span class="au-cat__emoji">🧸</span><span class="au-cat__label">Soft
          Toys</span></a>
      <a routerLink="/menu" class="au-cat"><span class="au-cat__emoji">👧</span><span class="au-cat__label">Dolls &amp;
          Playsets</span></a>
      <a routerLink="/menu" class="au-cat"><span class="au-cat__emoji">⚽</span><span class="au-cat__label">Outdoor
          Toys</span></a>
    </div>

  </div>
</section>


<!-- ═══════════════════════════════════════
     TESTIMONIAL
═══════════════════════════════════════ -->
<section class="au-quote">
  <div class="container">
    <div class="au-quote__card">
      <div class="au-quote__mark" aria-hidden="true">❝</div>
      <blockquote class="au-quote__text">
        Sangeetha Toys is more than a toy store—it's a destination where imagination
        comes to life. Our mission is to provide children with engaging, safe, and
        educational toys that encourage creativity, learning, and endless fun. We
        carefully select every product to ensure quality, value, and memorable
        experiences for families across generations.
      </blockquote>

      <div>
        <strong>Sangeetha Toys</strong>
        <span>Creating Happy Childhood Memories Since Day One</span>
        <div class="au-quote__stars">✨ Quality • Creativity • Trust</div>
      </div>
    </div>
  </div>
</section>


<!-- ═══════════════════════════════════════
     BOTTOM STATS DARK BAND
═══════════════════════════════════════ -->
<section class="au-stats-dark">
  <div class="container">
    <div class="row text-center gy-4">
      <div class="col-md-3 col-6">
        <h2 class="au-stats-dark__num">5000<span>+</span></h2>
        <p>Happy Customers</p>
      </div>
      <div class="col-md-3 col-6">
        <h2 class="au-stats-dark__num">1000<span>+</span></h2>
        <p>Toy Collections</p>
      </div>
      <div class="col-md-3 col-6">
        <h2 class="au-stats-dark__num">50<span>+</span></h2>
        <p>Trusted Brands</p>
      </div>
      <div class="col-md-3 col-6">
        <h2 class="au-stats-dark__num">100<span>%</span></h2>
        <p>Fun Guaranteed</p>
      </div>
    </div>
  </div>
</section>